import React from 'react';
import PropTypes from 'prop-types';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import { FormattedMessage } from 'react-intl';
import { Navigate } from 'react-router-dom';

const OperationalSetup = ({ userProfileWidgets }) => (
  <div>
    {IsWidgetAccessible(userProfileWidgets, 'MODELCATEGORY_TAB') ? (
      <Navigate to="/operational-setup/model-category-list" />
    ) : IsWidgetAccessible(userProfileWidgets, 'TASKSCHECKLISTS_TAB') ? (
      <Navigate to="/operational-setup/checklist-task-templates" />
    ) : (
      ''
    )}
    <span>
      <FormattedMessage
        id="OperationalSetup.NoAccess"
        defaultMessage="You do not have access to operational setup. Please contact your administrator."
      />
    </span>
  </div>
);

OperationalSetup.propTypes = {
  userProfileWidgets: PropTypes.object.isRequired
};

export default OperationalSetup;
